export default __webpack_public_path__ + "static/media/Gellix-Medium.3bd5d005.woff";